/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetUniverseTypesTypeIdNotFound
 */
export interface GetUniverseTypesTypeIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetUniverseTypesTypeIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetUniverseTypesTypeIdNotFound interface.
 */
export function instanceOfGetUniverseTypesTypeIdNotFound(value: object): value is GetUniverseTypesTypeIdNotFound {
    return true;
}

export function GetUniverseTypesTypeIdNotFoundFromJSON(json: any): GetUniverseTypesTypeIdNotFound {
    return GetUniverseTypesTypeIdNotFoundFromJSONTyped(json, false);
}

export function GetUniverseTypesTypeIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseTypesTypeIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetUniverseTypesTypeIdNotFoundToJSON(json: any): GetUniverseTypesTypeIdNotFound {
    return GetUniverseTypesTypeIdNotFoundToJSONTyped(json, false);
}

export function GetUniverseTypesTypeIdNotFoundToJSONTyped(value?: GetUniverseTypesTypeIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

